import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";

const OfferBanner = () => {
  const [offer, setOffer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOffer = async () => {
      try {
        const response = await axios.get(
          "https://admin.tulikaarts.in/api/offer"
        );
        if (response.data.status && response.data.offer) {
          setOffer(response.data.offer);
        }
      } catch (error) {
        console.error("Failed to fetch offer:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOffer();
  }, []);

  const bannerStyle = useMemo(
    () => ({
      backgroundImage: offer ? `url(${offer.offer_image})` : "none",
      backgroundSize: "cover",
      backgroundPosition: "center",
      width: "100%",
      padding: "2rem",
    }),
    [offer]
  );

  return (
    <div
      className="offer-banner d-flex align-items-center justify-content-center text-center text-white"
      style={bannerStyle}
    >
    </div>
  );
};

export default OfferBanner;
